import React from 'react';
import { Route as RouteIcon } from 'lucide-react';
import { ConnectionPath } from '../components/ConnectionPath';

export const ConnectionPathfinderLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <RouteIcon className="h-8 w-8 text-sage-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Connection Pathfinder (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm">Find meaningful paths between concepts; iterating in The Lab.</p>
      </div>

      <div className="bg-[var(--bg-raised)] border border-charcoal-200 p-4">
        <ConnectionPath />
      </div>
    </div>
  );
};


